export const TABLET_BREAK_POINT = 1050;
export const PHONE_BREAK_POINT = 700;
export const SMALL_PHONE_BREAK_POINT = 400;
export const HEADER_HEIGHT = 64;

export function getHeaderHeight(): number {
  return HEADER_HEIGHT;
}
